"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const AriaContext_1 = require("../../contexts/AriaContext");
const ProfilesContext_1 = require("../../contexts/profiles/ProfilesContext");
const ErrorHelper_1 = require("../../helpers/ErrorHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const ARootView_1 = require("../common/ARootView");
const StackNavigationView_1 = require("../common/StackNavigationView");
const Launcher_1 = require("./Launcher");
const ProfileView_1 = require("./ProfileView");
class RootView extends ARootView_1.ARootView {
    constructor(props) {
        super(props);
        this._onLaunchClick = () => {
            this.setState((oldState) => {
                return { launcherKey: oldState.launcherKey + 1 };
            });
        };
        const skypeId = RootView.getSkypeIdFromUrl();
        if (!skypeId) {
            throw ErrorHelper_1.displayableErrors.Generic;
        }
        LoggerHelper_1.logger.initCommonProperty({
            key: LoggerHelper_1.CommonProperty.Profile,
            value: skypeId,
        });
        this.state = {
            launcherKey: 0,
            profilesContext: { skypeId },
        };
    }
    static getSkypeIdFromUrl() {
        const pathName = window.location.pathname.replace(/\/+$/, '');
        const pathParts = pathName.split('/');
        return pathParts.pop();
    }
    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        return React.createElement(ProfilesContext_1.ProfilesContextProvider, { value: this.state.profilesContext },
            !!this.state.launcherKey && React.createElement(Launcher_1.Launcher, { key: this.state.launcherKey, profile: this.state.profilesContext }),
            React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement(StackNavigationView_1.StackNavigationView, { ariaContext: ariaContext, loading: this.props.loading, initialView: React.createElement(ProfileView_1.ProfileView, { onLaunchClick: this._onLaunchClick }), initialViewProps: { eventViewName: 'profile-view' } })));
    }
}
exports.RootView = RootView;
